module.exports = __webpack_public_path__ + "img/balao-ottinho@2x.ce5abdeb.png";